<template>
  <div class="other-fta">
    <div class="caption">
      <div class="title">
        {{linkType === 'rules' ? $t('query.result.other.otherRules') : $t('query.result.other.otherFta')}}
        <span style="color:#E02E24;vertical-align:super;font-size:10px;padding-left:3px;display:none;" v-if="$i18n.locale === 'zh-CN' && apiPrice && apiPrice(linkType === 'rules' ? 2 : 1).integral === 0">限免</span>
      </div>
    </div>
    
    <ul v-if="ranks.length > 0">
      <li v-for="(item, index) in ranks" :key="`other-fta-or-rule-${index}`">
        <a href="#" @click.stop.prevent="jfNotice($event, linkType, {name: linkType === 'rules' ? 'queryRules' : 'queryRateI', params: {exporter: item.exporter.id, importer: importerID, hscode: hscode}})">
          <img :src="item.exporter.icon">
          <div class="name ellipsis">{{item.exporter.name}}</div>
          <div class="value">
            <RateView :content="$options.filters.rateValueAccording(item.tax, item.description)" :strLen="8"></RateView>
          </div>
        </a>
      </li>
    </ul>
    <div class="nodata" v-else>{{$t('common.noResult')}}</div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import RateView from '@/components/query/common/RateView'
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')

export default {
  name: 'OtherFta',
  components: { RateView },
  props: {
    linkType: {
      type: String,
      default: 'rules',
      required: false
    },
    ranks: {
      type: Array,
      default: () => [],
      required: false
    },
    exporterID: {
      type: [String, Number]
    },
    importerID: {
      type: [String, Number]
    },
    hscode: {
      type: [String, Number]
    }
  },
  computed: {
    apiPrice () {
      if (this._.isEmpty(this.apiValue)) {
        return null
      } else {
        return this.getApiValue()
      }
    },
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  updated () {
    this.$nextTick(() => {
      this.$parent.refresh && this.$parent.refresh()
    })
  },
  methods: {
    jfNotice (event, linkType, params) {
      if (this.$i18n.locale !== 'zh-CN') {
        this.$router.push(params)
        return
      }
      this.GJFNotice(status => {
        if (status) {
          let jf = this.getApiValue()(linkType === 'rules' ? 2 : 1)
          if (jf && jf.integral && jf.integral > 0) {
            this.GConfirm(`本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`, status => {
              if (status) {
                this.$router.push(params)
              }
            })
          } else {
            this.$router.push(params)
          }
        } else {
          this.$router.push(params)
        }
      })
    },
    ...mapDataGetters(['getApiValue'])
  }
}
</script>
<style scoped>
  .caption{
    position: relative;
    margin-bottom: 18px;
  }
  .caption .title{
    color: #333;
    /*font-size: 11px;*/
    font-size: 13px;
    font-weight: bold;
  }
  ul li{
    margin-bottom: 18px;
    color: #333;
    /*font-size: 12px;*/
    font-size: 14px;
    cursor: pointer;
  }
  ul li:last-child{
    margin-bottom: 0;
  }
  ul li:hover{
    color: #1F8AFD;
  }
  ul li img{
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
  ul li .value{
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
  ul li a{
    display: block;
    position: relative;
    padding-left: 30px;
    padding-right: 50px;
    color: #333;
  }
  ul li a:hover{
    text-decoration: none;
    box-shadow: none;
    color: #1F8AFD;
  }
  ul li a:after{
    width: 0;
    height: 0;
    display: none;
  }
  .nodata{
    /*font-size: 11px;*/
    font-size: 13px;
    font-style: italic;
    color: #999;
  }
  /*.other-fta >>> .unit{*/
    /*font-size: 10px;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/query/common/OtherFta.vue